module.exports = __webpack_public_path__ + "img/Group 4.a94b313f.svg";